var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPhone)?_c('div',{staticClass:"ods-picker-panel__mobile-close",on:{"click":_vm.isPhoneClosePanel}},[_c('ods-icon',{attrs:{"name":"close","size":"32"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }